import * as React from 'react';
import { Dispatch, FC } from 'react';

import { ListItem } from '../ListItem';
import { EMAIL, PHONE, TELEGRAM_LOGO } from '../../../../constants/images';
import { NBSP } from '../../../../constants/symbols';
import { TG_URL } from '../../constants';
import { FormWrapper } from '../FormWrapper';
import { EActiveConsultationModal } from '../../../../types/redux/consultationRequest';

import styles from './styles.css';

interface IChoosingTypeConsultation {
  setActiveModal: Dispatch<React.SetStateAction<EActiveConsultationModal>>;
  tgUrl: string;
}
export const ChoosingTypeConsultation: FC<IChoosingTypeConsultation> = ({ setActiveModal }) => {
  const onRedirect = () => {
    window.location.href = TG_URL;
  };

  return (
    <FormWrapper
      title="Как хотите проконсультироваться?"
      subtitle={`Ответим на все вопросы с 09:00 до 18:00 по${NBSP}будням`}
    >
      <div className={styles['container']}>
        <ListItem
          title="По телефону"
          imageUrl={PHONE}
          handleClick={() => setActiveModal(EActiveConsultationModal.PhoneForm)}
        />
        <ListItem title="В персональном чате Telegram" imageUrl={TELEGRAM_LOGO} handleClick={onRedirect} />
        <ListItem
          title="По электронной почте"
          imageUrl={EMAIL}
          handleClick={() => setActiveModal(EActiveConsultationModal.EmailForm)}
        />
      </div>
    </FormWrapper>
  );
};
